const languages = [
  {
    code: 'en',
    isDefault: false,
    name: 'English',
    label: 'English',
  },
  {
    code: 'nl',
    isDefault: true,
    name: 'dutch',
    label: 'Nederlands',
  },
]

module.exports = languages
